<div class="loading-screen" *ngIf="loading">
  <div class="loading-background"></div>
  <div class="lds-css">
    <div style="width: 100%; height: 100%" class="lds-grid">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>

<ng-container *ngIf="session && idea">
  <div class="idea-hero" [ngClass]="{ unpublished: !idea.published }">
    <app-image-upload
      (uploadComplete)="uploadComplete($event)"
      (uploadStart)="uploadStart()"
      [defaultImage]="
        idea.thumbnail_id || 'image/default_idea_thumbnail.png'
      "></app-image-upload>

    <div class="unpublished-notice" *ngIf="!idea.published" placement="bottom">
      Project is not published
    </div>
  </div>
  <!-- <div class="flex flex-col justify-center"> -->
  <!-- Subnavigation Start -->
  <div
    class="px-4 sub-navigation top-nav d-flex justify-content-between align-items-center">
    <div class="fs-5">
      <a [routerLink]="['/topics', session._id]">
        {{ session.config.title }}
      </a>
      <span>&nbsp;&sol;&nbsp;</span>
      <span>{{ idea.title }}</span>
    </div>
    <div>
      <button
        *ngIf="!idea.i_follow"
        class="btn btn-lg icon-star-empty"
        (click)="follow()"
        title="Follow"></button>
      <button
        *ngIf="idea.i_follow"
        class="btn btn-lg icon-star-full"
        (click)="unfollow()"
        title="Unfollow"></button>
      <button
        *ngIf="permissions.session.data.ideas.publish(session, idea)"
        class="btn btn-lg fa fa-eye-slash"
        (click)="publish()"
        title="Publish Project"></button>
      <button
        *ngIf="permissions.session.data.ideas.unpublish(session, idea)"
        class="btn btn-lg fa fa fa-eye"
        (click)="unpublish()"
        title="Unpublish Project"></button>
      <button
        *ngIf="permissions.session.data.ideas.delete(session, idea)"
        class="btn btn-lg fa fa-trash"
        (click)="handleDeleteClick()"
        title="Delete Project"></button>
    </div>
  </div>
  <!-- Subnavigation End -->

  <!-- Idea Detail Start -->
  <div class="container idea-details transient-form-context py-5">
    <div class="row justify-content-center">
      <div class="col-md-11">
        <div class="row mb-3">
          <div class="col-12 d-flex gap-3 justify-content-end">
            <groupchat-button
              [session]="session"
              [idea]="idea"
              label="Discuss with Collaborators"
              *ngIf="
                permissions.session.data.ideas.put(session, idea)
              "></groupchat-button>

            <button class="btn btn-secondary" (click)="openIdeaModal()">
              People
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex flex-column gap-3">
            @if (idea.categories?.length) {
              <h3>{{ idea.categories.join(', ') }}</h3>
            }

            @if (!isEditing) {
              <h2>{{ idea.title }}</h2>
              <h3>{{ idea.one_liner }}</h3>
              <div>
                <div class="tag" *ngFor="let tag of idea.tags">{{ tag }}</div>
              </div>
            } @else {
              <input
                type="text"
                id="title"
                class="transient-input idea-name-input"
                name="idea-title"
                [(ngModel)]="idea.title"
                maxlength="{{ inputLengths.IDEA_TITLE }}"
                (ngModelChange)="titleChange.next(idea.title)"
                placeholder="Project Name" />
              <textarea
                id="one_liner"
                class="transient-input idea-one-liner-input"
                [(ngModel)]="idea.one_liner"
                maxlength="{{ inputLengths.IDEA_ONE_LINER }}"
                (ngModelChange)="onelinerChange.next(idea.one_liner)"
                placeholder="One-liner description"
                cdkTextareaAutosize></textarea>

              <tag-input
                class="mb-3"
                placeholder="Type and press enter ..."
                secondaryPlaceholder="Add some tags ..."
                [animationDuration]="{ enter: '0ms', leave: '0ms' }"
                [(ngModel)]="idea.tags"
                [modelAsStrings]="true"></tag-input>
              <ng-container *ngIf="suggestedTags.length > 0">
                <span class="hint">suggested tags:</span>
                <div
                  class="suggested-tag"
                  *ngFor="let tag of suggestedTags"
                  (click)="addTag(tag)">
                  {{ tag }}
                </div>
              </ng-container>
            }
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="p-3">
              <div
                class="form-check form-switch"
                style="font-size: 20px"
                *ngIf="permissions.session.data.ideas.put(session, idea)">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="editMode"
                  [ngModel]="isEditing"
                  (ngModelChange)="toggleEditMode($event)" />
                <label class="form-check-label" for="editMode">
                  <strong>Edit</strong>
                </label>
              </div>
            </div>
            <nav
              ngbNav
              #nav="ngbNav"
              class="nav-tabs script-tabs"
              [(activeId)]="activeScriptTab">
              @if (idea.outline) {
                <ng-container ngbNavItem="outline">
                  <button ngbNavLink [disabled]="disableEditing">
                    Outline
                  </button>
                  <ng-template ngbNavContent>
                    <div class="col">
                      @if (isEditing) {
                        <app-tiptap-editor
                          [formControl]="ideaForm.get('outline')"
                          (undo)="clearProcessResult()">
                          <button
                            *ngIf="ideaFeatureFlags.regenerateScript"
                            appTiptapEditorToolbarAppendix
                            type="button"
                            class="btn btn-primary"
                            title="Regenerate script"
                            [disabled]="disableEditing"
                            (click)="openRegenerateScriptModal()">
                            <i class="fa fa-sync"></i>
                          </button>
                          <ng-container
                            ngProjectAs="[appTiptapEditorToolbarAppendix]"
                            [ngTemplateOutlet]="commonControls"></ng-container>
                        </app-tiptap-editor>
                      } @else {
                        <div class="d-flex justify-content-end">
                          <ng-container
                            [ngTemplateOutlet]="commonControls"></ng-container>
                        </div>
                        <p class="idea-detail-description">
                          <prosemirror-view
                            [content]="idea.outline"></prosemirror-view>
                        </p>
                      }
                    </div>
                    <div class="col-3">
                      <div
                        class="d-flex flex-column gap-3 align-items-start sticky top-[85px]">
                        <ng-container
                          [ngTemplateOutlet]="userFeedback"></ng-container>
                        <ng-container
                          [ngTemplateOutlet]="
                            processDescription
                          "></ng-container>
                      </div>
                    </div>
                  </ng-template>
                </ng-container>
              }

              <ng-container ngbNavItem="text-script">
                <button ngbNavLink [disabled]="disableEditing">
                  Text Script
                </button>
                <ng-template ngbNavContent>
                  <div class="col">
                    @if (isEditing) {
                      <app-tiptap-editor
                        #textEditor
                        [formControl]="
                          ideaForm.get('textScript.original.value')
                        "
                        [footnotes]="idea.evidence"
                        (undo)="clearProcessResult()"
                        [shouldUnsetHighlight]="!ongoingProcess()">
                        <div class="btn-group" appTiptapEditorToolbarAppendix>
                          <button
                            type="button"
                            class="btn btn-primary"
                            title="Turn into bulletpoints"
                            [disabled]="disableEditing"
                            (click)="generateBulletpoints()">
                            <i class="fa fa-list"></i>
                          </button>
                          <button
                            class="btn btn-primary"
                            title="Regenerate script"
                            [disabled]="disableEditing"
                            (click)="openRegenerateScriptModal()"
                            *ngIf="ideaFeatureFlags.regenerateScript">
                            <i class="fa fa-sync"></i>
                          </button>
                        </div>
                        <ng-container
                          ngProjectAs="[appTiptapEditorToolbarAppendix]"
                          [ngTemplateOutlet]="commonControls"></ng-container>
                        <button
                          class="btn btn-primary"
                          [disabled]="disableEditing"
                          (click)="expandText()"
                          appTiptapEditorBubbleMenuItem>
                          Expand
                        </button>
                        <ng-container
                          ngProjectAs="[appTiptapEditorBubbleMenuItem]"
                          *ngIf="featureFlags.projectEdit.customInstruction">
                          <input
                            class="border-0 border-bottom border-white bg-transparent"
                            type="text"
                            [disabled]="disableEditing"
                            #customExpandInstruction
                            placeholder="Custom Instruction" />
                          <button
                            class="btn btn-primary rounded-circle"
                            [disabled]="disableEditing"
                            (click)="
                              expandText(customExpandInstruction.value);
                              customExpandInstruction.value = ''
                            ">
                            &rarr;
                          </button>
                        </ng-container>
                      </app-tiptap-editor>
                    } @else {
                      <div class="d-flex justify-content-end">
                        <ng-container
                          [ngTemplateOutlet]="commonControls"
                          [ngTemplateOutletContext]="{
                            hideCitations: true,
                          }"></ng-container>
                      </div>
                      <p class="idea-detail-description">
                        <prosemirror-view
                          [content]="
                            idea.textScript.original.value
                              | hideCitations: shouldHideCitations
                          "></prosemirror-view>
                      </p>
                    }
                    <ng-container [ngTemplateOutlet]="evidenceList" />
                  </div>
                  <div class="col-3">
                    <div
                      class="d-flex flex-column gap-3 align-items-start sticky top-[85px]">
                      @if (isEditing) {
                        <div class="btn-group" role="group">
                          <div class="btn-group" role="group" ngbDropdown>
                            <button
                              type="button"
                              class="btn btn-primary dropdown-toggle"
                              [disabled]="disableEditing"
                              ngbDropdownToggle>
                              Add facts
                            </button>
                            <div ngbDropdownMenu>
                              <buton
                                type="button"
                                class="dropdown-item"
                                ngbDropdownItem
                                (click)="addUniqueFacts()">
                                Automatically
                              </buton>
                              <buton
                                type="button"
                                class="dropdown-item"
                                ngbDropdownItem
                                (click)="displayUniqueFacts()">
                                Step-by-step
                              </buton>
                            </div>
                          </div>

                          @if (ideaFeatureFlags.missingFacts) {
                            <button
                              type="button"
                              class="btn btn-primary"
                              [disabled]="
                                disableEditing || idea.evidence.length === 0
                              "
                              (click)="findMissingFacts()">
                              Find missing facts
                            </button>
                          }
                          @if (ideaFeatureFlags.checkProblems) {
                            <button
                              type="button"
                              class="btn btn-primary"
                              [disabled]="isCheckDisabled"
                              (click)="check()">
                              Check
                            </button>
                          }
                        </div>
                        <div
                          class="flex flex-col gap-3 w-full"
                          *ngIf="featureFlags.projectEdit.customInstruction">
                          <div>
                            <label for="custom-instruction" class="form-label">
                              Your custom instructions
                            </label>
                            <textarea
                              class="form-control"
                              rows="5"
                              placeholder='e.g. "Make it less formal"'
                              id="custom-instruction"
                              [formControl]="customInstruction"></textarea>
                          </div>
                          <div class="flex justify-content-end">
                            <button
                              type="button"
                              class="btn btn-primary"
                              [disabled]="disableEditing"
                              (click)="submitCustomInstruction()">
                              Submit
                            </button>
                          </div>
                        </div>

                        @if (inconsistency) {
                          <div class="d-flex flex-column gap-2">
                            <h5>Potential inconsistencies:</h5>
                            <div>{{ inconsistency }}</div>
                          </div>
                        }
                        @if (foundAdditionalFacts) {
                          <app-evidence-facts-list
                            #evidenceFactsList
                            [evidence]="foundAdditionalFacts"
                            [selectable]="true"
                            [shortContent]="false"
                            [paginated]="true" />
                          <div class="d-flex justify-content-end">
                            <button
                              class="btn btn-primary"
                              (click)="
                                integrateFacts(
                                  evidenceFactsList.selectedEvidence
                                )
                              "
                              [disabled]="!evidenceFactsList.isAnySelected">
                              Integrate facts
                            </button>
                          </div>
                        }

                        @if (explanation.length) {
                          <div class="d-flex flex-column gap-2">
                            <h5>Explanation</h5>

                            @if (explanation.length === 1) {
                              <div>{{ explanation[0] }}</div>
                            } @else {
                              <ul class="d-flex flex-column gap-1">
                                @for (item of explanation; track $index) {
                                  <li>&mdash; {{ item }}</li>
                                }
                              </ul>
                            }
                          </div>
                        }

                        @if (missingFactsResult?.missing_facts_description) {
                          <div class="d-flex flex-column gap-2">
                            @if (missingFactsResult.missing_facts_description) {
                              <p>
                                <strong>Missing infos:</strong>
                                <app-short-content
                                  [content]="
                                    missingFactsResult.missing_facts_description
                                  "
                                  [length]="200"></app-short-content>
                              </p>
                            }
                            <app-missing-facts-list
                              #missingFactsList
                              [facts]="missingFactsResult.missing_facts_list"
                              [evidence]="
                                idea.evidence
                              "></app-missing-facts-list>
                            <div class="d-flex justify-content-end">
                              <button
                                class="btn btn-primary"
                                (click)="
                                  integrateMissingFacts(
                                    missingFactsList.selectedFacts
                                  )
                                "
                                [disabled]="!missingFactsList.isAnySelected">
                                Integrate facts
                              </button>
                            </div>
                          </div>
                        }
                        @if (problemsResult || inconsistenciesResult()) {
                          <div class="d-flex flex-column gap-2">
                            @if (problemsResult) {
                              <h5>Problems</h5>
                              <p>
                                {{
                                  problemsResult.problems_description !== 'N/A'
                                    ? problemsResult.problems_description
                                    : 'No problems found'
                                }}
                              </p>
                              @if (problemsResult.problems_list.length) {
                                <app-problems-list
                                  #problemsList
                                  [problems]="problemsResult.problems_list" />
                                <div class="d-flex justify-content-end">
                                  <button
                                    class="btn btn-primary"
                                    (click)="
                                      solveProblems(
                                        problemsList.formSerialize()
                                      )
                                    "
                                    [disabled]="
                                      !problemsList.isAnyProblemSelected
                                    ">
                                    Solve problems
                                  </button>
                                </div>
                              }
                            }
                            @if (inconsistenciesResult()) {
                              <h5>Inconsistencies</h5>
                              <p>
                                {{
                                  inconsistenciesResult()
                                    .inconsistencies_description !== 'N/A'
                                    ? inconsistenciesResult()
                                        .inconsistencies_description
                                    : 'No inconsistencies found'
                                }}
                              </p>
                              @if (
                                inconsistenciesResult().inconsistencies_list
                                  .length
                              ) {
                                <app-missing-facts-list
                                  #inconsistenciesList
                                  [facts]="
                                    inconsistenciesResult().inconsistencies_list
                                  "
                                  [isSelectable]="false"
                                  [evidence]="
                                    idea.evidence
                                  "></app-missing-facts-list>
                              }
                            }
                          </div>
                        }
                      } @else {
                        <ng-container
                          [ngTemplateOutlet]="comments"></ng-container>
                      }

                      <ng-container
                        [ngTemplateOutlet]="userFeedback"></ng-container>
                      <ng-container
                        [ngTemplateOutlet]="processDescription"></ng-container>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
              <ng-container ngbNavItem="phonetic-script">
                <button ngbNavLink [disabled]="disableEditing">
                  Phonetic Script
                </button>
                <ng-template ngbNavContent>
                  <div class="col">
                    @if (
                      isEditing &&
                      ideaForm.get('phoneticScript.original.value')!.value
                    ) {
                      <app-tiptap-editor
                        #textEditor
                        [formControl]="
                          ideaForm.get('phoneticScript.original.value')
                        "
                        (undo)="clearProcessResult()">
                        <ng-container
                          ngProjectAs="[appTiptapEditorToolbarAppendix]"
                          [ngTemplateOutlet]="commonControls"></ng-container>
                        <button
                          type="button"
                          class="btn btn-primary"
                          (click)="generatingAudioSnippet()"
                          appTiptapEditorBubbleMenuBtn>
                          Audio snippet
                        </button>
                      </app-tiptap-editor>
                    } @else if (
                      !isEditing && idea.phoneticScript?.original?.value
                    ) {
                      <div class="d-flex justify-content-end">
                        <ng-container
                          [ngTemplateOutlet]="commonControls"></ng-container>
                      </div>
                      <p class="idea-detail-description">
                        <prosemirror-view
                          [content]="
                            idea.phoneticScript?.original?.value ?? ''
                          "></prosemirror-view>
                      </p>
                    } @else {
                      <div>Phonetic Script will be displayed here</div>
                    }
                  </div>
                  <div
                    class="col-3 d-flex flex-column gap-3 align-items-start sticky top-[85px]">
                    @if (isEditing) {
                      <div class="btn-group" appTiptapEditorToolbarAppendix>
                        <button
                          type="button"
                          class="btn btn-primary"
                          title="Generate phonetic script"
                          [disabled]="disableEditing"
                          (click)="generatePhoneticScript()">
                          Generate Phonetic Script
                        </button>

                        @if (
                          !idea.inputParams?.promptLanguage ||
                          idea.inputParams?.promptLanguage === 'en'
                        ) {
                          <ng-container
                            *booleanFeatureFlag="
                              'audio-project';
                              default: false;
                              else: audioProjectDisabled
                            ">
                            <button
                              class="btn btn-primary"
                              [disabled]="disableEditing"
                              (click)="goTo('audio-project')">
                              Generate Audio
                            </button>
                          </ng-container>
                          <ng-template #audioProjectDisabled>
                            <button
                              class="btn btn-primary"
                              [disabled]="disableEditing"
                              (click)="generatingAudioSnippet()">
                              Generate Audio
                            </button>
                          </ng-template>
                        }
                      </div>

                      <ng-container
                        [ngTemplateOutlet]="userFeedback"></ng-container>

                      <ng-container
                        [ngTemplateOutlet]="processDescription"></ng-container>
                      @if (audioSnippetUrl) {
                        <audio controls [src]="audioSnippetUrl"></audio>
                      }
                    } @else {
                      <ng-container
                        [ngTemplateOutlet]="comments"></ng-container>
                    }
                  </div>
                </ng-template>
              </ng-container>
              <ng-container ngbNavItem="translations">
                <div class="btn-group" ngbDropdown>
                  <button ngbNavLink [disabled]="disableEditing">
                    Translations
                  </button>
                  @if (textScriptLanguages?.length) {
                    <button
                      type="button"
                      title="Languages"
                      class="btn dropdown-toggle-split nav-link"
                      [class.active]="activeScriptTab === 'translations'"
                      ngbDropdownToggle
                      [disabled]="disableEditing">
                      {{ selectedLanguage?.name }}
                    </button>
                    <div class="dropdown-menu" ngbDropdownMenu>
                      @for (lang of textScriptLanguages; track lang.code) {
                        <button ngbDropdownItem (click)="selectLanguage(lang)">
                          {{ lang.name }}
                        </button>
                      }
                    </div>
                  }
                </div>

                <ng-template ngbNavContent>
                  <div class="col">
                    @if (isEditing) {
                      @if (
                        selectedLanguage &&
                        (ideaForm
                          .get('textScript')
                          .get('lang_' + selectedLanguage.code)
                          ?.get('value'))!.value
                      ) {
                        <app-tiptap-editor
                          [formControl]="
                            ideaForm
                              .get('textScript')
                              .get('lang_' + selectedLanguage.code)
                              .get('value')
                          "
                          (undo)="clearProcessResult()">
                          <div
                            class="btn-group"
                            appTiptapEditorToolbarAppendix
                            ngbDropdown>
                            <button
                              type="button"
                              class="btn btn-primary dropdown-toggle"
                              title="Translate"
                              [disabled]="disableEditing"
                              ngbDropdownToggle>
                              <i class="fa fa-language"></i>
                            </button>
                            <div class="languages-dropdown" ngbDropdownMenu>
                              @for (lang of languages; track lang.code) {
                                <buton
                                  type="button"
                                  class="dropdown-item"
                                  ngbDropdownItem
                                  (click)="translate(lang)">
                                  {{ lang.code }} - {{ lang.name }}
                                </buton>
                              }
                            </div>
                          </div>
                          <ng-container
                            ngProjectAs="[appTiptapEditorToolbarAppendix]"
                            [ngTemplateOutlet]="commonControls"></ng-container>
                        </app-tiptap-editor>
                        <ng-container [ngTemplateOutlet]="evidenceList" />
                      } @else {
                        <div
                          class="d-flex justify-content-between align-items-center">
                          <div>
                            Generate the translation with the button on the
                            right
                          </div>
                          <div class="btn-group" role="group" ngbDropdown>
                            <button
                              type="button"
                              class="btn btn-primary dropdown-toggle"
                              [disabled]="disableEditing"
                              ngbDropdownToggle>
                              Translate
                            </button>
                            <div class="languages-dropdown" ngbDropdownMenu>
                              @for (lang of languages; track lang.code) {
                                <buton
                                  type="button"
                                  class="dropdown-item"
                                  ngbDropdownItem
                                  (click)="translate(lang)">
                                  {{ lang.code }} - {{ lang.name }}
                                </buton>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    } @else if (selectedLanguage) {
                      <div class="d-flex justify-content-end">
                        <ng-container
                          [ngTemplateOutlet]="commonControls"></ng-container>
                      </div>
                      <p class="idea-detail-description">
                        <prosemirror-view
                          [content]="
                            idea.textScript['lang_' + selectedLanguage.code]
                              .value | hideCitations: shouldHideCitations
                          "></prosemirror-view>
                      </p>
                      <ng-container [ngTemplateOutlet]="evidenceList" />
                    }
                  </div>
                  <div
                    class="col-3 d-flex flex-column gap-3 align-items-start sticky top-[85px]">
                    @if (isEditing) {
                      <ng-container
                        [ngTemplateOutlet]="userFeedback"></ng-container>

                      <ng-container
                        [ngTemplateOutlet]="processDescription"></ng-container>
                      @if (audioSnippetUrl) {
                        <audio controls [src]="audioSnippetUrl"></audio>
                      }
                    } @else {
                      <ng-container
                        [ngTemplateOutlet]="comments"></ng-container>
                    }
                  </div>
                </ng-template>
              </ng-container>
              <ng-container
                *booleanFeatureFlag="'audio-project'; default: false"
                ngbNavItem="audio-project">
                <ng-container>
                  <button ngbNavLink [disabled]="disableEditing">
                    Audio Project
                  </button>

                  <ng-template ngbNavContent>
                    <div class="col">
                      <app-audio-project [session]="session" [idea]="idea" />
                    </div>
                  </ng-template>
                </ng-container>
              </ng-container>
              <ng-container
                *booleanFeatureFlag="'video-project'; default: false"
                ngbNavItem="video-project">
                <ng-container>
                  <button ngbNavLink [disabled]="disableEditing">
                    Video Project
                  </button>

                  <ng-template ngbNavContent>
                    <div class="col">
                      <app-video-project [session]="session" [idea]="idea" />
                    </div>
                  </ng-template>
                </ng-container>
              </ng-container>
              @if (featureFlags.projectCreation.storyboard) {
                <ng-container ngbNavItem="storyboard">
                  <button ngbNavLink [disabled]="disableEditing">
                    Storyboard
                  </button>

                  <ng-template ngbNavContent>
                    <app-shots-list></app-shots-list>
                  </ng-template>
                </ng-container>
              }
            </nav>

            <div [ngbNavOutlet]="nav" class="mt-4 script-tab-content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Idea Detail End -->
</ng-container>

<ng-template #evidenceList>
  @if (
    idea.evidence
      | filterUsedCitations
        : (!ideaFeatureFlags.showAllCitations
            ? ideaForm.get('textScript.original.value')!.value
            : '');
    as usedEvidence
  ) {
    @if (usedEvidence.length) {
      <div class="mt-3" ngbAccordion>
        <div ngbAccordionItem [collapsed]="false">
          <h2 class="m-0" ngbAccordionHeader>
            <button ngbAccordionButton>Citations</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <app-evidence-facts-list
                  [evidence]="usedEvidence"
                  [selectable]="false"
                  [shortContent]="false"
                  [paginated]="false"></app-evidence-facts-list>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    }
  }
</ng-template>

<ng-template #commonControls let-hideCitations="hideCitations">
  <div class="btn-group ms-auto">
    @if (isEditing) {
      <button
        class="btn btn-primary"
        title="Save"
        [disabled]="
          featureFlags.projectEdit.polling &&
          (disableEditing || !hasUnsavedChanges)
        "
        (click)="saveIdea(true)">
        <i class="fa fa-save"></i>
      </button>
      <button
        class="btn btn-primary"
        title="Accept changes"
        [disabled]="disableEditing"
        (click)="acceptChanges('textScript.original')">
        <i class="fa fa-check-double"></i>
      </button>
    } @else if (hideCitations) {
      <button
        class="btn btn-primary"
        title="Toggle citations"
        [disabled]="disableEditing"
        (click)="shouldHideCitations = !shouldHideCitations">
        <i class="fa fa-quote-right"></i>
      </button>
    }
    <button
      class="btn btn-primary"
      title="Download"
      [disabled]="disableEditing"
      (click)="downloadScript()">
      <i class="fa fa-download"></i>
    </button>
    <div class="btn-group" ngbDropdown #copyDropdown="ngbDropdown">
      <button
        class="btn btn-primary"
        title="Copy"
        ngbDropdownAnchor
        [disabled]="disableEditing"
        (focus)="copyDropdown.open()">
        <i class="fa fa-paste"></i>
      </button>
      <div class="dropdown-menu" ngbDropdownMenu>
        <button
          ngbDropdownItem
          (click)="copyScriptToClipboard(ExportType.Text)">
          As text
        </button>
        <button
          ngbDropdownItem
          (click)="copyScriptToClipboard(ExportType.Markdown)">
          As markdown
        </button>
        <button
          ngbDropdownItem
          (click)="copyScriptToClipboard(ExportType.HTML)">
          As HTML
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #userFeedback>
  @if (featureFlags.projectEdit.feedback) {
    <app-user-feedback
      class="w-100"
      [session]="session"
      [idea]="idea"></app-user-feedback>
  }
</ng-template>

<ng-template #processDescription>
  @if (ongoingProcess()) {
    <div class="d-flex justify-content-end mt-3">
      <div class="d-flex justify-content-center align-items-center gap-2">
        <div class="spinner-grow text-primary" role="status">
          <span class="visually-hidden">{{ ongoingProcess() }}...</span>
        </div>
        <div>{{ ongoingProcess() }}...</div>
      </div>
    </div>
  }
</ng-template>

<ng-template #comments>
  <div class="comments-holder d-xs-none d-md-block">
    <comment-list
      *ngIf="session.config.comments.active"
      [idea]="idea"
      [session]="session"
      [standalone]="true"></comment-list>
  </div>
</ng-template>
